/* Noon — Interactive theme C: bean fill, buy box, sticky button, gallery, data-saver videos.
   Loads before noon-b.js so data-saver can stop clips before they are queued. */
(function () {
  if (window.__noonCInit) return;
  window.__noonCInit = true;
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };

  /* ---------- data-saver: skip the Seedance clips on Save-Data / 2G connections ---------- */
  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  var LITE = !!(conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')));
  function liteVideos(scope) {
    if (!LITE) return;
    document.documentElement.classList.add('nn-lite');
    Array.prototype.forEach.call((scope || document).querySelectorAll('video[data-nn-video]'), function (v) {
      v.__nn = true; v.__loaded = true;
      Array.prototype.forEach.call(v.querySelectorAll('source[data-src]'), function (s) { s.removeAttribute('data-src'); });
    });
  }

  function initBeanFill(canvas) {
    if (canvas.__nn || RM) return; canvas.__nn = true;
    var host = canvas.closest('.nn-hero') || canvas.parentElement, ctx = canvas.getContext('2d');
    var base = document.createElement('canvas'), bctx = base.getContext('2d');
    if (!ctx || !bctx) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 1.5), W = 0, H = 0;
    var reach = [0.95, 0.75, 0.55, 0.42, 0.32][clamp((parseInt(canvas.dataset.speed, 10) || 3) - 1, 0, 4)];
    var tones = ['#2B170C', '#3A2213', '#4B2D18', '#5A3A22', '#6B4429'], sprites = [], SZ = 56, REF = 16;
    var slots = [], keys = [], state = new Uint8Array(0), scheduled = 0, pending = [], flying = [];
    var dirty = false, lastBuild = 0, lastT = 0, raf = 0, tk = false;

    function makeSprites() {
      var sc = dpr * 1.15;
      sprites = tones.map(function (c) {
        var cv = document.createElement('canvas'); cv.width = cv.height = Math.ceil(SZ * sc);
        var g = cv.getContext('2d'), s = REF; g.scale(sc, sc); g.translate(SZ / 2, SZ / 2);
        g.fillStyle = 'rgba(30,16,7,.9)'; g.beginPath(); g.ellipse(1.5, 2.5, s * 1.14, s * 1.36, 0, 0, Math.PI * 2); g.fill();
        g.fillStyle = 'rgba(16,8,3,.55)'; g.beginPath(); g.ellipse(1, 2, s * .86, s * 1.12, 0, 0, Math.PI * 2); g.fill();
        g.fillStyle = c; g.beginPath(); g.ellipse(0, 0, s * .72, s, 0, 0, Math.PI * 2); g.fill();
        g.fillStyle = 'rgba(255,255,255,.09)'; g.beginPath(); g.ellipse(-s * .22, -s * .25, s * .22, s * .42, -.3, 0, Math.PI * 2); g.fill();
        g.strokeStyle = 'rgba(253,215,66,.5)'; g.lineWidth = s * .12; g.lineCap = 'round';
        g.beginPath(); g.moveTo(0, -s * .78); g.bezierCurveTo(s * .32, -s * .25, -s * .32, s * .25, 0, s * .78); g.stroke();
        return cv;
      });
    }
    function drawBean(g, sl, x, y, r) {
      var S = SZ * sl.s / REF;
      g.save(); g.translate(x, y); g.rotate(r); g.drawImage(sprites[sl.t], -S / 2, -S / 2, S, S); g.restore();
    }
    function build() {
      var rect = host.getBoundingClientRect();
      W = rect.width; H = rect.height;
      canvas.width = base.width = Math.max(1, Math.round(W * dpr)); canvas.height = base.height = Math.max(1, Math.round(H * dpr));
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0); bctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var small = W < 700, cw = small ? 19 : 23, ch = small ? 22 : 26;
      var p1 = Math.random() * 6, p2 = Math.random() * 6, p3 = Math.random() * 6;
      slots = [];
      for (var row = 0, y = H + 8; y > -ch; row++, y -= ch) {
        for (var x = (row % 2) * cw / 2 - cw / 2; x < W + cw; x += cw) {
          var px = x + (Math.random() - .5) * cw * .55, py = y + (Math.random() - .5) * ch * .55;
          var wave = Math.sin(px / 97 + p1) * 26 + Math.sin(px / 41 + p2) * 13 + Math.sin(px / 19 + p3) * 6;
          slots.push({ x: px, y: py, k: (H - py) + wave + Math.random() * 16, s: (small ? 10 : 12) + Math.random() * 4.5, r: Math.random() * Math.PI * 2, t: (Math.random() * tones.length) | 0 });
        }
      }
      slots.sort(function (a, b) { return a.k - b.k; });
      keys = slots.map(function (sl) { return sl.k; });
      state = new Uint8Array(slots.length); scheduled = 0; pending = []; flying = []; dirty = false;
      bctx.clearRect(0, 0, W, H); ctx.clearRect(0, 0, W, H);
      update(true);
    }
    function countBelow(h) { var lo = 0, hi = keys.length; while (lo < hi) { var m = (lo + hi) >> 1; if (keys[m] <= h) lo = m + 1; else hi = m; } return lo; }
    function progress() {
      var r = host.getBoundingClientRect(), y = window.scrollY || window.pageYOffset || 0;
      var start = Math.max(0, r.top + y - window.innerHeight * .5);
      return clamp((y - start) / (H * reach), 0, 1);
    }
    function bake(i) { state[i] = 3; drawBean(bctx, slots[i], slots[i].x, slots[i].y, slots[i].r); }
    function rebuild(t) {
      bctx.clearRect(0, 0, W, H);
      for (var i = 0; i < scheduled; i++) if (state[i] === 3) drawBean(bctx, slots[i], slots[i].x, slots[i].y, slots[i].r);
      dirty = false; lastBuild = t;
    }
    function setTarget(n, instant) {
      if (n > scheduled) {
        for (var i = scheduled; i < n; i++) { if (instant) bake(i); else { state[i] = 1; pending.push(i); } }
        scheduled = n;
      } else if (n < scheduled) {
        for (var j = n; j < scheduled; j++) { if (state[j] === 3) dirty = true; state[j] = 0; }
        pending = pending.filter(function (i) { return i < n; });
        flying = flying.filter(function (f) { return f.i < n; });
        scheduled = n;
      }
    }
    function frame(t) {
      raf = 0;
      var dt = clamp((t - (lastT || t)) / 16.67, 0, 3); lastT = t;
      if (pending.length > 420) pending.splice(0, pending.length - 260).forEach(bake);
      var top = clamp(-host.getBoundingClientRect().top, 0, H);
      for (var k = 0; k < 28 && pending.length && flying.length < 380; k++) {
        var i = pending.shift(), sl = slots[i]; state[i] = 2;
        flying.push({ i: i, x: sl.x + (Math.random() - .5) * 70, y: Math.min(top - 30 - Math.random() * 140, sl.y - 60), vy: 1.5 + Math.random() * 3, r: Math.random() * 6.283, vr: (Math.random() - .5) * .28 });
      }
      for (var f = flying.length - 1; f >= 0; f--) {
        var b = flying[f], s2 = slots[b.i];
        b.vy += .62 * dt; b.y += b.vy * dt; b.x += (s2.x - b.x) * Math.min(1, .09 * dt); b.r += b.vr * dt;
        if (b.y >= s2.y) { flying.splice(f, 1); s2.r = b.r; bake(b.i); }
      }
      if (dirty && t - lastBuild > 70) rebuild(t);
      ctx.clearRect(0, 0, W, H);
      ctx.drawImage(base, 0, 0, W, H);
      for (var q = 0; q < flying.length; q++) { var fb = flying[q]; drawBean(ctx, slots[fb.i], fb.x, fb.y, fb.r); }
      if (flying.length || pending.length || dirty) raf = requestAnimationFrame(frame);
    }
    function kick() { if (!raf) { lastT = 0; raf = requestAnimationFrame(frame); } }
    function update(instant) {
      tk = false;
      if (!host.isConnected) { window.removeEventListener('scroll', onScroll); return; }
      var p = progress();
      host.classList.toggle('is-filling', p > .02);
      setTarget(p <= 0 ? 0 : countBelow(p * (H + 90)), instant);
      if (instant) { ctx.clearRect(0, 0, W, H); ctx.drawImage(base, 0, 0, W, H); }
      kick();
    }
    function onScroll() { if (!tk) { tk = true; requestAnimationFrame(function () { update(false); }); } }
    makeSprites(); build();
    window.addEventListener('scroll', onScroll, { passive: true });
    var rt, lw = W, lh = H;
    function onResize() { clearTimeout(rt); rt = setTimeout(function () { var r = host.getBoundingClientRect(); if (Math.abs(r.width - lw) > 2 || Math.abs(r.height - lh) > 2) { build(); lw = W; lh = H; } }, 200); }
    window.addEventListener('resize', onResize);
    if ('ResizeObserver' in window) new ResizeObserver(onResize).observe(host);
  }

  /* ---------- buy box: subscribe / one-time, bags, first-box offer, price per cup ---------- */
  function initBuy(form) {
    if (form.__nn) return; form.__nn = true;
    var data = form.querySelector('[data-nn-variants]'); if (!data) return;
    var variants = []; try { variants = JSON.parse(data.textContent); } catch (e) { return; }
    var cur = form.getAttribute('data-currency') || 'USD';
    var fmt; try { fmt = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: cur }); } catch (e) { fmt = null; }
    var money = function (c) { return fmt ? fmt.format(c / 100) : '$' + (c / 100).toFixed(2); };
    var cups = parseInt(form.getAttribute('data-cups'), 10) || 24, pct = parseInt(form.getAttribute('data-pct'), 10) || 0, min = parseInt(form.getAttribute('data-min'), 10) || 2;
    var q = function (sel) { return form.querySelector(sel); };
    var out = function (k) { return form.querySelector('[data-out="' + k + '"]'); };
    var idIn = q('[data-nn-id]'), qtyIn = q('[data-nn-qty]'), planIn = q('[data-nn-plan]'), cta = q('[data-nn-cta]'), sel = q('[data-nn-variant]');
    var bags = Array.prototype.slice.call(form.querySelectorAll('[data-bags]'));
    var modes = Array.prototype.slice.call(form.querySelectorAll('[data-nn-mode]'));
    var label = cta ? cta.textContent : 'Add to cart';
    var state = { v: null, qty: parseInt(qtyIn.value, 10) || 1 };
    function variant() { var id = parseInt(sel ? sel.value : idIn.value, 10); for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i]; return variants[0]; }
    function mode() { for (var i = 0; i < modes.length; i++) if (modes[i].checked) return modes[i].value; return 'once'; }
    function render() {
      var v = variant(), m = mode();
      if (m === 'sub' && !v.plan) { m = 'once'; modes.forEach(function (x) { x.checked = x.value === 'once'; }); }
      var unit = m === 'sub' ? v.plan.price : v.price, total = unit * state.qty;
      var offer = m === 'sub' && pct > 0 && state.qty >= min;
      idIn.value = v.id; qtyIn.value = state.qty;
      if (planIn) { if (m === 'sub' && v.plan) { planIn.disabled = false; planIn.value = v.plan.id; } else { planIn.disabled = true; planIn.value = ''; } }
      var subU = out('sub-unit'), onceU = out('once-unit');
      if (subU && v.plan) subU.textContent = money(v.plan.price) + '/bag';
      if (onceU) onceU.textContent = money(v.price) + '/bag';
      out('now').textContent = money(offer ? Math.round(total * (100 - pct) / 100) : total);
      var was = out('was');
      var wasVal = offer ? total : (m === 'once' && v.compare > v.price ? v.compare * state.qty : 0);
      was.hidden = !wasVal; was.textContent = wasVal ? money(wasVal) : '';
      out('cup').textContent = money(Math.round(unit / cups)) + ' a cup';
      var planName = v.plan ? v.plan.name : '';
      out('note').textContent = offer ? 'Your first box. Then ' + money(total) + ' per box, ' + planName.charAt(0).toLowerCase() + planName.slice(1) + '.'
        : (m === 'sub' ? planName + '.' : (v.plan && pct > 0 ? 'Subscribe with ' + min + '+ bags to get ' + pct + '% off your first box.' : 'Ships in 1–3 business days.'));
      bags.forEach(function (b) { b.setAttribute('aria-pressed', parseInt(b.dataset.bags, 10) === state.qty ? 'true' : 'false'); });
      form.classList.toggle('is-sub', m === 'sub');
      if (cta) { cta.disabled = !v.available; cta.textContent = v.available ? label : 'Sold out'; }
    }
    bags.forEach(function (b) { b.addEventListener('click', function () { state.qty = parseInt(b.dataset.bags, 10) || 1; render(); }); });
    modes.forEach(function (x) { x.addEventListener('change', render); });
    if (sel) sel.addEventListener('change', render);
    render();
  }

  /* ---------- sticky mobile button ---------- */
  function initSticky(bar) {
    if (bar.__nn) return; bar.__nn = true;
    var after = parseInt(bar.getAttribute('data-after'), 10) || 600, tk = false;
    var href = (bar.querySelector('a') || {}).getAttribute ? bar.querySelector('a').getAttribute('href') : '';
    var hash = href && href.indexOf('#') > -1 ? href.slice(href.indexOf('#')) : '';
    var target = hash.length > 1 ? document.querySelector(hash) : null;
    var inView = false;
    if (target && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { inView = e[0].isIntersecting; upd(); }, { rootMargin: '0px 0px -20% 0px' }).observe(target);
    }
    var foot = document.querySelector('.nn-footer'), footIn = false;
    if (foot && 'IntersectionObserver' in window) new IntersectionObserver(function (e) { footIn = e[0].isIntersecting; upd(); }).observe(foot);
    function upd() {
      tk = false;
      var on = window.scrollY > after && !inView && !footIn;
      bar.classList.toggle('is-on', on);
      document.documentElement.classList.toggle('nn-sticky-on', on);
    }
    window.addEventListener('scroll', function () { if (!tk) { tk = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }

  /* ---------- product page thumbnails ---------- */
  function initGallery(root) {
    if (root.__nn) return; root.__nn = true;
    var main = root.querySelector('[data-nn-main]'); if (!main) return;
    Array.prototype.forEach.call(root.querySelectorAll('[data-nn-thumb]'), function (t) {
      t.addEventListener('click', function () {
        main.src = t.getAttribute('data-src'); if (t.getAttribute('data-srcset')) main.srcset = t.getAttribute('data-srcset'); else main.removeAttribute('srcset');
        Array.prototype.forEach.call(root.querySelectorAll('[data-nn-thumb]'), function (o) { o.setAttribute('aria-current', o === t ? 'true' : 'false'); });
      });
    });
  }

  function init(scope) {
    var root = scope || document, each = function (sel, fn) { Array.prototype.forEach.call(root.querySelectorAll(sel), fn); };
    liteVideos(root);
    each('canvas.nn-beanfill', initBeanFill);
    each('form[data-nn-buy]', initBuy);
    each('[data-nn-sticky]', initSticky);
    each('[data-nn-gallery]', initGallery);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
